<template>
  <v-col cols="12" class="pa-0">
    <video-metrics-options
      :handleSelectOption="handleSelectOption"
      v-if="currentDisplay === 'options'"
      class="px-3"
    />
    <video-views
      :handleBack="handleBackOptions"
      v-else-if="currentDisplay === 'views'"
      class="px-3"
    />
    <video-retention
      :handleBack="handleBackOptions"
      v-else-if="currentDisplay === 'retention'"
      :videoHls="videoHls"
      :videoPlayer="videoPlayer"
    />
    <video-retention
      :handleBack="handleBackOptions"
      v-else-if="currentDisplay === 'retentionDrm'"
      :videoPlayer="videoPlayer"
    />
    <video-traffic
      :handleBack="handleBackOptions"
      v-else-if="currentDisplay === 'traffic'"
    />
  </v-col>
</template>

<script>
import VideoMetricsOptions from './VideoMetricsOptions.vue'
import VideoViews from './VideoViews.vue'
import VideoRetention from './VideoRetention.vue'
import VideoTraffic from '../info/VideoTraffic.vue'

export default {
  name: 'VideoMetrics',
  props: ['videoPlayer', 'videoHls'],
  components: { VideoMetricsOptions, VideoViews, VideoRetention, VideoTraffic },
  data: () => ({
    currentDisplay: 'options',
  }),
  methods: {
    handleSelectOption(option) {
      this.currentDisplay = option
    },
    handleBackOptions() {
      this.handleSelectOption('options')
    },
  },
}
</script>

<style></style>
